export type PreferredMapType = 'roadmap' | 'satellite'

const mapTypeStorageKey = 'mapapal.mapType'

export function readPreferredMapType(
  storage: Pick<Storage, 'getItem'> = localStorage,
): PreferredMapType {
  return storage.getItem(mapTypeStorageKey) === 'satellite' ? 'satellite' : 'roadmap'
}

export function storePreferredMapType(
  mapType: PreferredMapType,
  storage: Pick<Storage, 'setItem'> = localStorage,
): void {
  storage.setItem(mapTypeStorageKey, mapType)
}
